import gql from 'graphql-tag';

import { orderItemFragment } from './orderItemsFragment';

export const orderFragment = gql`
  fragment OrderFragment on Order {
    id
    amountDue
    isFirstPaidOrder
    requiresPaymentMethod
    requiresStoreInVault
    status
    type
    userId
    processorVersion
    createdAt
    updatedAt
    orderItems {
      ...OrderItemFragment
    }
  }

  ${orderItemFragment}
`;
